import ProductCardSkeleton from '@/components/common/Skeleton/new-product-card';

const ProductLineSkeleton: React.FC<any> = ({ viewRef }) => {
  return (
    <div className="my-2.5" ref={viewRef}>
      <div className="flex flex-row justify-between items-center mb-2 px-3">
        <div className="bg-surface-200-bg inline-block w-16 h-6 leading-8  rounded-sm skeleton" />
        <div className="bg-surface-200-bg inline-block w-16 h-5 leading-8  rounded-sm skeleton" />
      </div>
      <div className="max-w-full overflow-hidden">
        <div className="box-border flex w-[477px] px-3">
          {new Array(3).fill(0).map((_item, index) => {
            return <ProductCardSkeleton className="mr-3" key={`product-array-skeleton-${index}`} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default ProductLineSkeleton;
